const facilities = [
  {
    name: "Anchorage Main Post Office",
    address: "3201 C St, Anchorage, AK 99503",
    phone: "(907) 564-2000",
    hours: "Mon–Fri 8:30am–5:00pm",
    note: "Accepts passport applications; photo services on site",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Dimond Center Post Office",
    address: "800 E Dimond Blvd, Anchorage, AK 99515",
    phone: "(907) 522-3522",
    hours: "Mon–Fri 9:00am–5:00pm",
    note: "South Anchorage acceptance facility",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Eagle River Post Office",
    address: "10928 Eagle River Rd, Eagle River, AK 99577",
    phone: "(907) 694-8590",
    hours: "Mon–Fri 9:00am–5:00pm",
    note: "Serving Eagle River and Chugiak",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Anchorage Municipal Clerk",
    address: "Pouch 6-650, 632 W 6th Ave, Anchorage, AK 99519",
    phone: "(907) 343-4311",
    hours: "Mon–Fri 8:00am–5:00pm",
    note: "Municipal acceptance facility downtown",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Midtown Post Office",
    address: "2025 E Northern Lights Blvd, Anchorage, AK 99508",
    phone: "(907) 258-3390",
    hours: "Mon–Fri 9:00am–5:30pm",
    note: "Midtown Anchorage acceptance location",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Wasilla Post Office",
    address: "400 N Yenlo St, Wasilla, AK 99654",
    phone: "(907) 376-5656",
    hours: "Mon–Fri 9:00am–5:00pm",
    note: "Mat-Su Borough acceptance facility",
    website: "https://tools.usps.com/find-location.htm",
  },
];

export default function AcceptanceFacilitiesSection() {
  return (
    <section id="acceptance-facilities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Anchorage
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            First-time applicants (and those who can&apos;t mail-renew) need to visit an acceptance facility in person. Here are the main locations near Anchorage.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {facilities.map((f, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
                <i className="ri-government-line text-[#1A365D] text-lg"></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{f.name}</h3>
              <p className="text-gray-500 text-xs mb-1 flex items-start gap-1.5">
                <i className="ri-map-pin-line mt-0.5 flex-shrink-0 text-[#F6C344]"></i>
                {f.address}
              </p>
              <p className="text-gray-500 text-xs mb-1 flex items-center gap-1.5">
                <i className="ri-phone-line flex-shrink-0 text-[#F6C344]"></i>
                {f.phone}
              </p>
              <p className="text-gray-500 text-xs mb-1 flex items-center gap-1.5">
                <i className="ri-time-line flex-shrink-0 text-[#F6C344]"></i>
                {f.hours}
              </p>
              <p className="text-gray-500 text-xs mb-1 flex items-center gap-1.5">
                <i className="ri-global-line flex-shrink-0 text-[#F6C344]"></i>
                <a
                  href={f.website}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2"
                >
                  Visit website
                </a>
              </p>
              {f.note && (
                <p className="text-gray-400 text-xs mt-3 pt-3 border-t border-gray-100">{f.note}</p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 bg-[#1A365D] rounded-lg p-6 text-center">
          <p className="text-white/80 text-sm mb-2">
            Skip the acceptance facility line — if you&apos;re eligible to renew by mail, Fast Passport Center handles everything remotely.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap mt-3"
          >
            Check My Eligibility <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}